/**
 * @generated SignedSource<<68850ce36b2119ba1a338d862de136f9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EmailLayoutList_query$data = {
  readonly emailLayouts: ReadonlyArray<{
    readonly createdAt: any;
    readonly emailLayoutIdentifier: string;
    readonly id: string;
    readonly isDefault: boolean;
    readonly name: string;
    readonly updatedAt: any;
  }>;
  readonly " $fragmentType": "EmailLayoutList_query";
};
export type EmailLayoutList_query$key = {
  readonly " $data"?: EmailLayoutList_query$data;
  readonly " $fragmentSpreads": FragmentRefs<"EmailLayoutList_query">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EmailLayoutList_query",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "EmailLayout",
      "kind": "LinkedField",
      "name": "emailLayouts",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "emailLayoutIdentifier",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isDefault",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "createdAt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "updatedAt",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "254d752bf8c8f9955b07eee2e43c8906";

export default node;
